<template>
    <footer class="app-footer">
      <a href="https://www.tjpa.jus.br/PortalExterno/" target="_blank" rel="noopener noreferrer">
        <img class="footer-logo" src="../assets/selo-tj-white.png" alt="Tribunal de Justiça do Estado do Pará" />
      </a>
    </footer>
  </template>
  
  <script>
  export default {
  }
  </script>
  
  <style scoped>
html, body {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

#app {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.app-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1e469a;
  padding: 20px 0;
  margin-top: auto; 
}

.footer-logo {
  width: 366px;
  height: auto;
  max-width: 100%;
}

  </style>
  